import Container from "@/components/Container/Container";
import Section from "@/components/Section/Section";
import PageHero from "@/components/PageHero/PageHero";
import ContactForm from "@/components/ContactForm/ContactForm";
import { site } from "@/content/site";
import styles from "./ContactPage.module.css";

const channels = [
  {
    label: "Insurance",
    title: "Verify benefits via Headway",
    body: "Use Headway to confirm coverage, copays, and deductibles before scheduling.",
    href: site.links.headway,
    cta: "Open Headway",
  },
  {
    label: "Directory",
    title: "Lea on Psychology Today",
    body: "View my full clinical profile, specialties, and licensure details.",
    href: site.links.psychologyToday,
    cta: "Visit profile",
  },
  {
    label: "Brainspotting",
    title: "Listed in the Brainspotting Directory",
    body: "Find me in the official Brainspotting trained-clinicians directory.",
    href: site.links.brainspottingDirectory,
    cta: "Open directory",
  },
  {
    label: "Professional",
    title: "Connect on LinkedIn",
    body: "For supervision inquiries, professional consultation, or networking.",
    href: site.links.linkedIn,
    cta: "Open LinkedIn",
  },
];

export default function ContactPage() {
  return (
    <>
      <PageHero
        eyebrow="Get in touch"
        title="Therapy starts with a single conversation."
        intro="Reach out to schedule a free 15-minute consultation, ask questions about my approach, or inquire about supervision. I respond to messages within two business days."
        accent="bloom"
      />

      <Section spacing="loose">
        <Container width="default" className={styles.layout}>
          <div className={styles.formCol}>
            <ContactForm />
          </div>

          <aside className={styles.aside} aria-label="Other ways to reach out">
            <h2 className={styles.asideTitle}>Other ways to connect</h2>
            <ul className={styles.channels}>
              {channels.map((c) => (
                <li key={c.title} className={styles.channel}>
                  <span className="eyebrow">{c.label}</span>
                  <h3 className={styles.channelTitle}>{c.title}</h3>
                  <p>{c.body}</p>
                  <a
                    href={c.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.channelLink}
                  >
                    {c.cta} &nbsp;→
                  </a>
                </li>
              ))}
            </ul>
          </aside>
        </Container>
      </Section>
    </>
  );
}
